import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/reset.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/styles/tailwind.css'
import i18n from '@/plugins/i18n'
// =========== 版本信息 ===========
import { printVersionInfo } from './common/basis/types/version'

// 项目初始化时打印版本信息
printVersionInfo()
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app
  .use(store)
  .use(router)
  .use(i18n)
  .use(ElementPlus, {
    locale: zhCn
  })
  .mount('#app')
